function handleHeader() {
  const mainHeader = document.getElementById("main-header");
  if (!mainHeader) return;

  const setHeaderHeightVar = () => {
    const h = mainHeader.getBoundingClientRect().height;
    document.documentElement.style.setProperty("--aw-header-height", `${h}px`);
  };

  setHeaderHeightVar();
  window.addEventListener("resize", setHeaderHeightVar);

  // Watch the header itself — image/font loads, CTA visibility changes etc. all reshape it
  // after DOMContentLoaded fires, and the mobile menu's top offset reads from this var.
  if (typeof ResizeObserver !== "undefined") {
    new ResizeObserver(setHeaderHeightVar).observe(mainHeader);
  }

  let lastKnownScrollPosition = 0;
  let upAnchorY = 0;
  let upAnchorTime = 0;
  const UP_TRIGGER_PX = 200;
  const UP_TRIGGER_WINDOW_MS = 1000;

  function handleStickyNav() {
    const now = performance.now();
    const dir = window.scrollY > lastKnownScrollPosition ? "down" : "up";
    const scrolledPast = window.scrollY > mainHeader!.offsetHeight;
    const mobileOpen = mainHeader!.querySelector("[x-data]")?.classList.contains("is-mobile-open") ||
      document.body.classList.contains("overflow-hidden");

    // Anchor sits at the peak of the most recent down-scroll; resets every 1s so the
    // trigger measures "100px up within the last second", not "100px up since page load".
    if (dir === "down" || now - upAnchorTime > UP_TRIGGER_WINDOW_MS) {
      upAnchorY = window.scrollY;
      upAnchorTime = now;
    }
    const fastUp = upAnchorY - window.scrollY >= UP_TRIGGER_PX;

    if (mobileOpen || !scrolledPast || fastUp) {
      mainHeader!.classList.remove("is-hidden");
    } else if (dir === "down") {
      mainHeader!.classList.add("is-hidden");
    }

    lastKnownScrollPosition = window.scrollY;
  }

  document.addEventListener("scroll", handleStickyNav, { passive: true });
}

document.addEventListener("DOMContentLoaded", handleHeader);
